﻿export function formatUserName(firstName: string | null | undefined, lastName: string | null | undefined): string {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- We want to include empty strings as well
  return firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || '';
}
